import { IAppState } from '../../../AppModulesWrapper';
import { IExperiments } from '../../types/reducers/experiments';

export const selectExperiments = (state: IAppState): IExperiments => {
  return state.servicePickerWidget.experiments;
};
